import ReactToPrint from 'react-to-print';
import { List, Card, Row, Col, Tooltip } from 'antd';
import { primaryColors, secondaryColors } from '../common/colors';

const MyList = ( { dataSource, printElements, isLoading, ref, itemsRef, height } ) => {

    return (
    <>
        <div style={{ overflow: 'hidden', height: 0 }} >
            <div ref={ref}>
                {printElements.header('Catálogo Ecolistico')}
                <List
                style={{ margin: 20 }}
                itemLayout="horizontal"
                dataSource={dataSource}
                renderItem={(item, i) => {
                    let specs='';
                    let hStyle = { backgroundColor: secondaryColors.white, color: primaryColors.grey, 'fontSize': '1.3rem', padding: 10, textAlign: 'center' };
                    let myImg = <img width="30" height="30" alt="Brote logo" src={'/catalogo/img/brote.png'}/>;

                    if(item.name.toLowerCase().includes('brote')) {
                    specs = '* Compra mínima 50 g';
                    hStyle = {...hStyle, backgroundColor: secondaryColors.blue};
                    myImg = <img width="30" height="30" alt="Brote logo" src={'/catalogo/img/brote.png'}/>;
                    }
                    else if(item.name.toLowerCase().includes('flor exótica')) {
                    specs = '* Compra mínima 20 pza';
                    hStyle = {...hStyle, backgroundColor: secondaryColors.red, color: 'white'};
                    myImg = <img width="30" height="30" alt="Flor logo" src={'/catalogo/img/flor.png'}/>;
                    }
                    else if(item.name.toLowerCase().includes('hoja baby premium')) {
                    specs = '* Compra mínima 100 g';
                    hStyle = {...hStyle, backgroundColor: secondaryColors.violet, color: 'white' };
                    myImg = <img width="30" height="30" alt="Baby logo" src={'/catalogo/img/baby.png'}/>;
                    }
                    else if(item.name.toLowerCase().includes('hoja baby')) {
                    specs = '* Compra mínima 100 g';
                    hStyle = {...hStyle, backgroundColor: secondaryColors.yellow };
                    myImg = <img width="30" height="30" alt="Baby logo" src={'/catalogo/img/baby.png'}/>;
                    }
                    else if(item.name.toLowerCase().includes('hoja premium')) {
                    specs = '* Compra mínima 50 pza';
                    hStyle = {...hStyle};
                    myImg = <img width="30" height="30"  alt="Hoja logo" src={'/catalogo/img/hoja.png'}/>;
                    }
                    else if(item.name.toLowerCase().includes('hoja selecta')) {
                    specs = '* Compra mínima 100 g';
                    hStyle = {...hStyle, backgroundColor: secondaryColors.green };
                    myImg = <img width="30" height="30" alt="Selecta logo" src={'/catalogo/img/selecta.png'}/>;
                    }

                    return (
                    <>
                        <Card
                            headStyle = {hStyle}
                            title={item.name}
                            ref={itemsRef.current[i]}
                            >
                            <List
                            grid={{gutter: [10, 10], column: 3}}
                            itemLayout="horizontal"
                            dataSource={item.products}
                            renderItem={el => {
                                if(el.url!== undefined && el.url.startsWith('http')){
                                    return(
                                        <>
                                            <Tooltip title="Ver la ficha técnica">
                                                <a href={el.url} target="_blank">
                                                    <box-icon type='solid' color={primaryColors.green} name='spreadsheet'/>
                                                </a>
                                            </Tooltip>
                                            <b>{el.name}</b>
                                        </>
                                    );
                                }
                                return <><b>{el.name}</b></>; 
                            }}
                            />
                            <Row justify="center" align="middle" style={{ marginTop: 20 }}>
                                <Col span={2}>
                                    {myImg}
                                </Col>
                            </Row>
                        </Card>
                        <div style={{height: height[i] }}>  </div>
                    </>
                    );}}
                />
                {printElements.date}
                {printElements.advertise}
            </div>
        </div>
        {printElements.header('Catálogo')}
        <List
        style={{margin: 20, overflow: 'auto', height: '50vh'}}
        loading={(isLoading)}
        itemLayout="horizontal"
        dataSource={dataSource}
        renderItem={item => {
            let specs='';
            let hStyle = { backgroundColor: secondaryColors.white, color: primaryColors.grey, 'fontSize': '1.3rem', padding: 10, textAlign: 'center' };
            let myImg = <img width="30" height="30" alt="Brote logo" src={'/catalogo/img/brote.png'}/>;

            if(item.name.toLowerCase().includes('brote')) {
            specs = '* Compra mínima 50 g';
            hStyle = {...hStyle, backgroundColor: secondaryColors.blue};
            myImg = <img width="30" height="30" alt="Brote logo" src={'/catalogo/img/brote.png'}/>;
            }
            else if(item.name.toLowerCase().includes('flor exótica')) {
            specs = '* Compra mínima 20 pza';
            hStyle = {...hStyle, backgroundColor: secondaryColors.red, color: 'white'};
            myImg = <img width="30" height="30" alt="Flor logo" src={'/catalogo/img/flor.png'}/>;
            }
            else if(item.name.toLowerCase().includes('hoja baby premium')) {
            specs = '* Compra mínima 100 g';
            hStyle = {...hStyle, backgroundColor: secondaryColors.violet, color: 'white' };
            myImg = <img width="30" height="30" alt="Baby logo" src={'/catalogo/img/baby.png'}/>;
            }
            else if(item.name.toLowerCase().includes('hoja baby')) {
            specs = '* Compra mínima 100 g';
            hStyle = {...hStyle, backgroundColor: secondaryColors.yellow };
            myImg = <img width="30" height="30" alt="Baby logo" src={'/catalogo/img/baby.png'}/>;
            }
            else if(item.name.toLowerCase().includes('hoja premium')) {
            specs = '* Compra mínima 50 pza';
            hStyle = {...hStyle};
            myImg = <img width="30" height="30"  alt="Hoja logo" src={'/catalogo/img/hoja.png'}/>;
            }
            else if(item.name.toLowerCase().includes('hoja selecta')) {
            specs = '* Compra mínima 100 g';
            hStyle = {...hStyle, backgroundColor: secondaryColors.green };
            myImg = <img width="30" height="30" alt="Selecta logo" src={'/catalogo/img/selecta.png'}/>;
            }

            return (
            <Card
                headStyle = {hStyle}
                title={item.name}
                >
                <List
                    grid={{gutter: [10, 10], column: 3}}
                    itemLayout="horizontal"
                    dataSource={item.products}
                    renderItem={el => {
                        if(el.url!== undefined && el.url.startsWith('http')){
                            return(
                                <>
                                    <Tooltip title="Ver la ficha técnica">
                                        <a href={el.url} target="_blank">
                                            <box-icon type='solid' color={primaryColors.green} name='spreadsheet'/>
                                        </a>
                                    </Tooltip>
                                    <b>{el.name}</b>
                                </>
                            );
                        }
                        return <><b>{el.name}</b></>; 
                    }}
                />
                <Row justify="center" align="middle" style={{ marginTop: 20 }}>
                    <Col span={0}>
                        <b>{specs}</b>
                    </Col>
                    <Col span={2}>
                        {myImg}
                    </Col>
                </Row>
            </Card>
            );}}
        />
        {printElements.date}
        {printElements.advertise}

        <ReactToPrint
                    trigger={() => printElements.triggerPrint()}
                    content={() => ref.current}
                    onBeforeGetContent={printElements.handleBeforeGetContent}
                    onAfterPrint={printElements.handleAfterPrint}
                    documentTitle={'catalogo_por_categoria'}
        />
    </>
)};

export default MyList;